// eslint-disable-next-line import/prefer-default-export
/** @jsx jsx */
/** @jsxFrag React.Fragment */
import React from "react";
import { jsx } from "theme-ui";
import DefaultLayout from "../../components/layout/layout";

const Layout: React.FC = ({ children }) => <DefaultLayout>{children}</DefaultLayout>;
export default Layout;
